<template>
  <div>
    <view-table
        ref="vmTable"
        url="materialLabelPrints/page/template"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        :table-select="false"
        module="basic"
        @reset="handleReset"
        @delete="handleDelete"
        @addOrEdit="handleAddOrEdit">
      <template #adSearch>
        <el-form :inline="true" :model="filter" @keyup.enter.native="getList(1)">
          <el-form-item label="模板名称">
            <el-input v-model.trim="filter.templateName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="模板类型">
            <el-input v-model.trim="filter.templateTypeName" placeholder="请输入" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
    <material-label-print-template-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>

<script>

  import MaterialLabelPrintTemplateEdit from "@/views/MaterialLabel/MaterialLabelPrintTemplateEdit.vue";
  import ViewTable from "@/components/ViewTable.vue";

  export default {
    name: "MaterialLabelPrintTemplateList",
    components: {ViewTable, MaterialLabelPrintTemplateEdit},
    data() {
      return {
        limits: {
          delAuth: this.$auth(739),
          editAuth: this.$auth(738),
          addAuth: this.$auth(737),
        },
        filter: {
          templateTypeName: "",
          templateName: "",
        },
        columnsProperty: [
          {
            key: "action",
            width: 150,
            slot: "action",
            align: "center",
          },
        ],
      };
    },
    mounted() {
      // this.getList(1);
    },
    methods: {
      getList(num) {
        this.$refs.vmTable.loadData(num);
      },
      handleAddOrEdit(row) {
        if (row) {
          this.$refs.editPage.open(row.id);
        } else {
          this.$refs.editPage.open();
        }
      },
      handleReset(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      handleDelete(row) {
        this.$http.delete("basic","materialLabelPrints/template",row.id).then(() => {
          this.getList(-1);
          this.$message.success("删除成功");
        });
      },
    },
  };
</script>

<style scoped>

</style>
